import { Beneficiary } from 'types';

export default function getBeneficiaryPlan(
  beneficiary: Beneficiary,
  plans: any[]
) {
  return plans?.find((currentPlan) => currentPlan['_id'] === beneficiary?.plan);
}
